// extracted by mini-css-extract-plugin
export var modal = "_gc-0";